import { FC, ReactNode } from 'react';
import Image from "next/image";

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    children: ReactNode;
    maxWidth?: string;
}

const Modal: FC<ModalProps> = ({ isOpen, onClose, title, children, maxWidth = "max-w-lg" }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex justify-center items-start bg-black bg-opacity-50 z-50 py-8 overflow-y-auto">
            <div className={`bg-white p-10 rounded-lg shadow-lg ${maxWidth} w-full relative my-auto max-h-[calc(100vh-4rem)] overflow-y-auto`}>
                <button
                    className="absolute top-2 right-4 text-2xl text-gray-600 hover:text-gray-900"
                    onClick={onClose}
                >
                    &times;
                </button>
                <div className="mb-8">
                    <Image
                        src="/img/gobo-black-square.png"
                        alt="Gobo Logo"
                        width={40}
                        height={40}
                    />
                </div>
                <h1 className="text-xl font-semibold text-customGray text-transform-none normal-case mb-4">{title}</h1>
                {children}
            </div>
        </div>
    );
};

export default Modal;